import { DATA_NORMALIZER_FOR_BACKEND } from 'modules/Distances/components/shared/Steps';
import { State as UserInputData } from 'modules/Distances/shared/stateHelpers';

export const formatData = (relation: string, data: UserInputData | any): any => {
  const normalize = DATA_NORMALIZER_FOR_BACKEND[relation] || DATA_NORMALIZER_FOR_BACKEND.default;

  return normalize(data[relation]);
};
